import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { api } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const loginAPI = createApi({
    reducerPath: 'loginAPI',
    baseQuery: axiosBaseQuery(api),
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.LOGIN,
                method: 'POST',
                data,
            }),
        }),
        logout: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.LOGOUT,
                method: 'POST',
            }),
        }),
    }),
});

export const { useLoginMutation, useLogoutMutation } = loginAPI;
